/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AuthConfiguration, IptvLoginResponse } from 'client-code/iptv-login';
import { LicensePlate, SamlToken } from 'client-code/device-binding-service';
import { IAuthServices } from '../interfaces/IAuthServices';
import { Log } from '../logging/Log';
import { IptvLoginService } from './IptvLoginService';
import { DeviceBindingService } from './DeviceBindingService';

export class AuthServices implements IAuthServices {
    private TAG: string = 'AuthServices';

    async getAuthConfiguration(): Promise<AuthConfiguration> {
        try {
            return await new IptvLoginService().fetchAndGetAuthConfiguration();
        } catch (error) {
            Log.e(this.TAG, 'getAuthConfiguration', error);
            throw error;
        }
    }

    async getLicensePlate(): Promise<LicensePlate> {
        try {
            return await new DeviceBindingService().fetchLicensePlate(false);
        } catch (error) {
            Log.e(this.TAG, 'getLicensePlate', error);
            throw error;
        }
    }

    async getNewLicensePlate(): Promise<LicensePlate> {
        try {
            return await new DeviceBindingService().fetchLicensePlate(true);
        } catch (error) {
            Log.e(this.TAG, 'getNewLicensePlate', error);
            throw error;
        }
    }

    async getSamlTokenByLicensePlateCode(code?: string): Promise<SamlToken> {
        try {
            return await new DeviceBindingService().fetchSamlToken(code);
        } catch (error) {
            Log.e(this.TAG, 'getSamlTokenByLicensePlateCode', error);
            throw error;
        }
    }

    async getIptvLoginBySamlToken(samlToken: string): Promise<IptvLoginResponse> {
        try {
            return await new IptvLoginService().getIptvLoginBySamlToken(samlToken);
        } catch (error) {
            Log.e(this.TAG, 'getIptvLoginBySamlToken', error);
            throw error;
        }
    }

    async removeDeviceBinding(): Promise<void> {
        try {
            return await new DeviceBindingService().removeDeviceBinding();
        } catch (error) {
            Log.e(this.TAG, 'AuthServices::removeDeviceBinding()', error);
            throw error;
        }
    }
}
